import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleManager = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        let title = 'DecoTV';

        if (path === '/') title = 'Dashboard | DecoTV';
        else if (path.includes('/store-locator')) title = 'Store Locator | DecoTV';
        else if (path.includes('/profile')) title = 'Dealer Profile | DecoTV';
        else if (path.includes('/inventory')) title = 'Inventory | DecoTV';
        else if (path.includes('/login')) title = 'Login | DecoTV';
        else if (path.includes('/register')) title = 'Register | DecoTV';

        document.title = title;
    }, [location]);

    return null;
};

export default TitleManager;
